<template>
  <CustomPicker
    :isInDialog="isInDialog"
    :isLoading="isLoading"
    :closeOnSelect="true"
    title="title"
    :inputLabel="inputLabel"
    v-model="selectedLiteracyBadge"
    :items="literacyBadgeList"
    @open="onOpen"
    @close="onClose"
  >
    <!-- @search="handleSearch" -->
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">در حال لود...</li>
    </template>
  </CustomPicker>
</template>
<script>
export default {
  emits: ["getLiteracyBadge"],
  props: {
    defaultSelectedLiteracyBadgeId: {
      type: [String, Number],
      required: false,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: String,
      default: "بج سواد مورد نظر را انتخاب کنید",
    },
  },

  watch: {
    selectedLiteracyBadge: {
      handler(val) {
        this.$emit("getLiteracyBadge", val);
      },
    },
  },

  mounted() {
    this.getAllBadges();
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },

  data() {
    return {
      isLoading: false,
      literacyBadgeList: null,
      totalCount: null,
      selectedLiteracyBadge: null,
      literacyBadgeFilters: {
        count: 20,
        pageNumber: 1,
      },
      timeOut: null,
      observer: null,
    };
  },
  methods: {
    async getAllBadges() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllLiteracyBadges = new GetAllLiteracyBadges(_this);
        getAllLiteracyBadges.setRequestParam(_this.literacyBadgeFilters);
        await getAllLiteracyBadges.fetch((res) => {
          _this.literacyBadgeList = res.data.data;
          _this.totalCount = res.data.totalCount;
          if (_this.defaultSelectedLiteracyBadgeId) {
            _this.selectedLiteracyBadge = _this.literacyBadgeList.find(
              (item) => {
                return item.id == _this.defaultSelectedLiteracyBadgeId;
              }
            );
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        this.$nextTick(() => {
          this.observer.observe(this.$refs.load);
        });
      }
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        if (this.hasNextPage) {
          this.literacyBadgeFilters.pageNumber++;
        }
      }
    },
    onClose() {
      this.observer.disconnect();
    },

    // handleSearch(searchValue, loadingFn) {
    //   if (this.timeOut) {
    //     clearTimeout(this.timeOut);
    //   }
    //   this.timeOut = setTimeout(async () => {
    //     this.literacyBadgeFilters.searchCommand = searchValue;
    //     loadingFn(true);
    //     await this.getAllBadges();
    //     loadingFn(false);
    //   }, 300);
    // },
  },
  computed: {
    hasNextPage() {
      if (
        this.totalCount &&
        this.totalCount / this.literacyBadgeFilters.count >
          this.literacyBadgeFilters.pageNumber
      ) {
        return true;
      }
      return false;
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetAllLiteracyBadges } from "@/libs/Api/LiteracyBadge";
</script>
